import { ITransaction } from './shared/layout/checkout/agent-sitef/agent-sitef.component';
import { AgentSitefService } from './shared/layout/checkout/agent-sitef/agent-sitef.service';
import { CartHelperService } from '@app/store/cart/cart-helper-service';
import { TerminalSettingsService } from 'congress/shared/layout/terminal/terminal-settings.service';
import { AfterViewInit, Component, Injector, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AppAuthService } from "@app/shared/common/auth/app-auth.service";
import { AppConsts } from "@shared/AppConsts";
import { AppComponentBase } from "@shared/common/app-component-base";
declare var $: JQuery;

@Component({
    selector: "app-congress",
    templateUrl: "./congress.component.html",
    styleUrls: ["./congress.component.css", "./shared/common/styles/congress.css"],
})
export class CongressComponent
    extends AppComponentBase
    implements OnInit, AfterViewInit
{

    constructor(
        injector: Injector,
        private route: ActivatedRoute,
        private _router: Router,
        private _authService: AppAuthService,
        private _cartHelperService: CartHelperService,
        private _terminalSettingsService: TerminalSettingsService,
        private _agentSitefService: AgentSitefService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe((params: Params) => {

            let logout = params["logout"];
            if (logout) {

                this._cartHelperService.clearCart();

                this._authService.logout(
                    true,
                    AppConsts.appBaseUrl + "/congresso/home"
                );

                this._agentSitefService.clearSitefStorage();
                localStorage.removeItem("showRegistrationMessage");


            }
            else{
               this._router.navigate(["congresso/home"]);
            }
        });

    this.checkPendingTransaction();



    }

    ngAfterViewInit() {
        if (this.appSession.user && this._terminalSettingsService.getSettings()) {
            //Init user session
            //Inactivity time 60 seconds
            $.sessionTimeout({
                title: "Você ainda está ai?",
                message: "Sua sessão está prestes a expirar.",
                keepAlive: false,
                redirUrl: AppConsts.appBaseUrl + "/congresso?logout=true",
                logoutUrl: AppConsts.appBaseUrl + "/congresso?logout=true",
                warnAfter: this._terminalSettingsService._settings.sessionTimeoutSeconds ?  this._terminalSettingsService._settings.sessionTimeoutSeconds * 1000 : 60000, //warn after 60 seconds
                redirAfter: this._terminalSettingsService._settings.sessionNoticeTimeoutSeconds ? (this._terminalSettingsService._settings.sessionTimeoutSeconds * 1000) + (this._terminalSettingsService._settings.sessionNoticeTimeoutSeconds * 1000) : 90000, //redirect after 90 seconds,
                ignoreUserActivity: false,
                countdownMessage: "Encerrando a sessão em {timer} segundos.",
                countdownBar: true,
                keepAliveButton: "Continuar",
                logoutButton: "Sair",
            });
        }
    }

    checkPendingTransaction(){

        let pendingTransaction = localStorage.getItem('pending-transaction') ? JSON.parse(localStorage.getItem('pending-transaction')) as ITransaction : undefined;

        if(pendingTransaction){
            this.notify.info('Verificando transações pendentes', "Verificando Pendências");

            this._agentSitefService.finish(0, true, true, pendingTransaction.cupomFiscal, pendingTransaction.sitefIp, pendingTransaction.empresa, pendingTransaction.terminal, pendingTransaction.initialParams);

            this.notify.success('Transação pendente cancelada: ' + pendingTransaction.cupomFiscal, 'Transações Pendentes', { timeOut: 300000, closeButton: true } );
        }


    }


}





// WEBPACK FOOTER //
// ./src/congress/congress.component.ts